// colorContrast.ts — is a background light or dark, so the icons and labels drawn on it can be black or white.
// Reads #rgb, #rrggbb, #rrggbbaa (alpha ignored), rgb() and rgba(). Anything else counts as dark, which keeps the
// white-on-dark look the toolbar icons were drawn for.

const LIGHT_THRESHOLD = 186; // perceived brightness (0 to 255) above which black reads better than white

function parseRgb(color: string): [number, number, number] | null {
  const c = color.trim().toLowerCase();
  const hex = /^#([0-9a-f]{3,8})$/.exec(c);
  if (hex) {
    const h = hex[1];
    if (h.length === 3 || h.length === 4) {
      return [parseInt(h[0] + h[0], 16), parseInt(h[1] + h[1], 16), parseInt(h[2] + h[2], 16)];
    }
    if (h.length === 6 || h.length === 8) {
      return [parseInt(h.slice(0, 2), 16), parseInt(h.slice(2, 4), 16), parseInt(h.slice(4, 6), 16)];
    }
    return null;
  }
  const rgb = /^rgba?\(\s*(\d{1,3})\s*[, ]\s*(\d{1,3})\s*[, ]\s*(\d{1,3})/.exec(c);
  return rgb ? [Number(rgb[1]), Number(rgb[2]), Number(rgb[3])] : null;
}

export function isLightColor(color?: string | null): boolean {
  const rgb = color ? parseRgb(color) : null;
  if (!rgb) return false;
  const [r, g, b] = rgb;
  return (r * 299 + g * 587 + b * 114) / 1000 > LIGHT_THRESHOLD;
}
